"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormMigrateModalCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var CollectionFormMigrateModalCtrl = /** @class */ (function () {
    function CollectionFormMigrateModalCtrl(collections) {
        this.failures = [];
        this.updatingForm = false;
        this.collections = collections;
    }
    CollectionFormMigrateModalCtrl.prototype.updateFormCollections = function (targetFormVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionUuids;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setUpdatingForm(true);
                        collectionUuids = this.collections.map(function (c) { return c.uuid; });
                        return [4 /*yield*/, services_1.Services.Department.rest.Collection.migrate({
                                collections: collectionUuids.map(function (uuid) { return ({ uuid: uuid }); }),
                                targetFormVersion: targetFormVersion
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, page_state_1.CurrentState.updateInspectedCollection()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.refresh(collectionUuids)];
                    case 3:
                        _a.sent();
                        this.setUpdatingForm(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    CollectionFormMigrateModalCtrl.prototype.refresh = function (collectionUuids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collectionSummaries;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(collectionUuids.map(function (uuid) { return store_1.AppStore.CollectionSummary.getFetchableByUuid(uuid).refetch(); }))];
                    case 1:
                        collectionSummaries = _a.sent();
                        return [2 /*return*/, Promise.all(tslib_1.__spreadArray([
                                store_1.AppStore.Tag.refresh()
                            ], this.getTagIds(collectionSummaries).map(function (tagId) { return store_1.AppStore.TagSummary.getFetchable(tagId).refetch(); }), true))];
                }
            });
        });
    };
    CollectionFormMigrateModalCtrl.prototype.getTagIds = function (collectionSummaries) {
        var tags = {};
        for (var _i = 0, collectionSummaries_1 = collectionSummaries; _i < collectionSummaries_1.length; _i++) {
            var collectionSummary = collectionSummaries_1[_i];
            for (var _a = 0, _b = collectionSummary.tags; _a < _b.length; _a++) {
                var tag = _b[_a];
                if (!tags[tag] && !(0, core_api_1.isSystemTag)(tag)) {
                    tags[tag] = true;
                }
            }
        }
        return Object.keys(tags);
    };
    CollectionFormMigrateModalCtrl.prototype.setUpdatingForm = function (updatingForm) {
        this.updatingForm = updatingForm;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], CollectionFormMigrateModalCtrl.prototype, "updatingForm", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionFormMigrateModalCtrl.prototype, "setUpdatingForm", null);
    return CollectionFormMigrateModalCtrl;
}());
exports.CollectionFormMigrateModalCtrl = CollectionFormMigrateModalCtrl;
//# sourceMappingURL=collection.form.migrate.modal.ctrl.js.map